import React from 'react';
import PersonPage from './PersonPage';

export default function AuthorPage() {
  return <PersonPage endpoint="authors" label="Author" />;
}
